<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide scrollable :mask="false" draggable class="insert_edit_dept">
      <div class="pop_top">
        <div class="dept_edit_input">
          <div class="font_style_set">上级部门:</div>
          <Select v-model="higherLevelDept" :disabled="disabled">
            <Option v-for="(option, index) in higherLevelDeptList" :value="option.id" :key="index">{{option.deptName}}</Option>
          </Select>
        </div>
        <div class="dept_edit_input">
          <div class="font_style_set">部门名称:</div>
          <Input v-model="deptName"/>
          <span style="color: red;margin-left: 5px">*</span>
        </div>
        <div class="dept_edit_input">
          <div class="font_style_set">部门说明:</div>
          <Input v-model="deptDescr" type="textarea" :autosize="{minRows: 5,maxRows: 100}"/>
        </div>
      </div>
      <div class="btn_template">
        <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
        <Button type="primary" class="submit_btn" @click="save()">保存</Button>
      </div>
  </Modal>
</template>

<script>
    export default {
        name: "DepartmentManagePop",
        props: {
          showDept:Boolean,
          higherLevelDeptList:Array,
          deptId:String,
          title:String,
          menuId:String,
          journalType:String ,
          pid:String
        },
        data(){
          return{
            model:false,
            disabled:true,
            higherLevelDept:'',
            deptName:'',
            deptDescr:'',
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
          }
        },
        methods:{
          cancel:function(){
            this.$emit("closeDept",false);
          },
          save:function(){
            if(!this.deptName){
              this.$Modal.info({
                title:'提示',
                content:"部门名称不能为空"
              });
              return false;
            }
            let param={
              journalType:this.journalType,
              menuId:this.menuId,
              id:this.deptId,
              pid:this.higherLevelDept,
              deptName:this.deptName,
              descr:this.deptDescr
            };
            let that=this;
            this.$http.post("deptment/doSave.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.$Message.info("保存成功");
              that.$emit("closeDept",true);
            });
          },
          initSearch:function (id) {
            let param={
              id:id,
              journalType:"null",
              menuId:"null"
            };
            let that=this;
            this.$http.post("deptment/toIndex.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              let list=res.data.obj.tree;
              if(list.length>0){
                that.deptName=list[0].deptName;
                that.deptDescr=list[0].descr;
              }
            });
          }
        },
        watch:{
          showDept:function () {
            this.model=this.showDept;
            this.deptName="";
            this.deptDescr="";
            if(!this.showDept){
              return false;
            }
            if(this.deptId){
              this.initSearch(this.deptId);
              for (let i=0;i<this.higherLevelDeptList.length;i++){
                let id=this.higherLevelDeptList[i].id;
                if(id==this.deptId){
                  let pid=this.higherLevelDeptList[i].pid;
                  this.higherLevelDept=pid;
                }
              }
              return false;
            }
            this.higherLevelDept=this.pid;
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/userManagement/DepartmentManagePop.vue